const currencyGuide = {  
  id: "currency-guide",
  title: "Currencies",
  category: "Component",
  override: "wiki/beginner/currencies",
  sections: [{
    id: "cur_coins",
    title: "Coins",
    description:
      "Coins are the in-game primary currency that you use to play the game. They will be the currency you see the most, and it is highly inflationary. The primary use of this token is to participate in game loops and buy items to progress within the game.",
    tradeable: true,
    canWithdraw: false,
  },{
    id: "cur_ape",
    title: "$APE",
    description:
      "$APE was momentarily used as a reward for the Otherspeck Event. The game rewarded $APE coupons and allowed players to withdraw the currency!",
    tradeable: false,
    canWithdraw: true,
    canGet: false,
  },
  {
    id: "cur_pixel",
    title: "$PIXEL",
    description:
      "$PIXEL is the premium currency that should be used for improvement, quality of life, and pretty shiny things! Like a Racecar bed (yes that's real!). This token is capped, and can be traded on Ronin, Binance and Coinbase for FIAT or other tokens/currencies<br/><br/>$PIXEL TGE Date: February 19th, 2024<br/><p className='text-xs'>🗒️ This <a href='https://cryptorank.io/price/pixels/vesting' className='wiki-links' rel='noreferrer' target='_blank'>website</a> has a lot of super in-depth detail about the $PIXEL vesting. Should check it out!<br/></p><p className='text-xs'>🗒️ This <a href='https://api.pixels.foundation/' className='wiki-links' rel='noreferrer' target='_blank'>website</a> is the information from Pixels Foundation!</p>",
    tradeable: false,
    canWithdraw: true,
    canGet: true,
  },
  {
    id: "cur_speedup",
    title: "Quicksilver",
    description:
      "Quicksilver is a currency that was introduced March 12, 2025 as a way to quickly gain access to industries.<br/>You can purchase it with $PIXEL via the Bank (or by clicking the $PIXEL currency in the top left. You use it on an industry, and reserve the industry for 30 seconds to craft or use for yourself.<br/>You can also use it on your own crafting or resource, but it won't be reserved.",
    tradeable: false,
    canWithdraw: false,
    canGet: true,
  },
  {
    id: "cur_buoybuck",
    title: "Buoy Bucks",
    description:
      "Buoy Bucks is the Merchant Fleet currency, introduced April 2nd, 2025 when Merchant Fleet was released. You can earn these by completing missions for the Merchant Fleet, or by fishing and selling the fish to the Cod Stewart! Buoy Bucks are used to purchase items from the Rotating Store on the Pier",
    tradeable: false,
    canWithdraw: false,
    canGet: true,
  },
  {
    id: "cur_cyber",
    title: "$CYBER",
    description:
      "$CYBER is the in-game currency for the Nucyber Platform which is a game built on the Pixels Engine. It can be used for their game's primary game loop, but it cannot be traded, bought, sold or otherwise used.",
    tradeable: false,
    canWithdraw: false,
    canGet: true,
  },
  {
    id: "cur_berry",
    title: "$BERRY",
    description:
      "$BERRY was the first token on Pixels, and was sunset in February 2024 just before $PIXEL was released. The token was highly inflationary, and traded on the market.",
    tradeable: false,
    canWithdraw: false,
    canGet: false,
  },
  {
    id: "cur_chain",
    title: "PixTix",
    description:
      "PixTix were a currency released in October/November 2024 for a Binance in-game event. You could use them to redeem some prizes from a pop-up store!",
    tradeable: false,
    canWithdraw: false,
    canGet: false,
  },
  {
    id: "cur_pepe",
    title: "$PEPE",
    description:
      "$PEPE is a meme coin that was randomly imported to Pixels on May 11, 2023. The team also added a random outhouse where you could buy $PEPE Fertilizer using the meme coin. It was removed around half a year later.",
    tradeable: false,
    canWithdraw: true,
    canGet: false,
  },
  {
    id: "cur_nana",
    title: "$NANA",
    description:
      "$NANA was a token introduced in April 2023 for the Tastemakerz Event. It could only be used in the Tastemakerz environment. It could be earned by selling crops and burgers, and put you on the leaderboard to win grand prizes!",
    tradeable: false,
    canWithdraw: false,
    canGet: false,
  },
  {
    id: "cur_other",
    title: "$OTHER",
    description:
      "$OTHER was a token introduced in September 2023 for the Otherspeck Event. It could only be used in the Otherspeck environment. It could be earned by selling Gems in the Otherspeck Universe, and put you on the leaderboard to win grand prizes!",
    tradeable: false,
    canWithdraw: false,
    canGet: false,
  },
  {
    id: "cur_wron",
    title: "$WRON",
    description:
      "$WRON is Wrapped Ronin which was temporarily used between the period of November 2023 and February 2024 to purchase VIP. When $PIXEL released, the VIP cost was transitioned to $PIXEL",
    tradeable: false,
    canWithdraw: true,
    canGet: false,
  },
  {
    id: "cur_teeth",
    title: "Teeth",
    description:
      "TEETH was a currency designed for the Halloween Event in October 2024. It could be earned by playing the Halloween version of Whack-a-Mole, and was spent to win big prizes",
    tradeable: false,
    canWithdraw: false,
    canGet: false,
  },
  {
    id: "cur_super",
    title: "$SUPER",
    description:
      "SUPER was a currency that could be imported for a limited time to purchase Stars to complete a $SUPER quest in November 2024. Players needed to deposit $10 worth of $SUPER to win some shades",
    tradeable: false,
    canWithdraw: false,
    canGet: false,
  },
  {
    id: "cur_guildtoken",
    title: "Guild Runes",
    description:
      "Guild Tokens were rewarded weekly and seasonally as part of the Spore Sports Season 2 Event. Guild Tokens are expected to stick around, and can be used to purchase items from the Spore Sports Store",
    tradeable: false,
    canWithdraw: false,
    canGet: false,
  },
  {
    id: "cur_mistletoe_white",
    title: "White Mistletokens",
    description: "White Mistletokens were a currency used in the Winter Carnival 2024 to purchase prizes from the White Mistletoken Store!",
    tradeable: false,
    canWithdraw: false,
    canGet: false,
  },
  {
    id: "cur_mistletoe_green",
    title: "Green Mistletokens",
    description: "Green Mistletokens were a currency used in the Winter Carnival 2024 to purchase prizes from the Green Mistletoken Store!",
    tradeable: false,
    canWithdraw: false,
    canGet: false,
  },
  {
    id: "cur_mistletoe",
    title: "Red Mistletokens",
    description: "Red Mistletokens were a currency used in the Winter Carnival 2024 to purchase prizes from the Red Mistletoken Store!",
    tradeable: false,
    canWithdraw: false,
    canGet: false,
  },
  {
    id: "cur_liveops",
    title: "Stuff Stubs",
    description: "Stuff Stubs are ticket rewards from Neon Zone games that you can trade in for prizes at either the Zonez Store, or the Fortune Teller!",
    tradeable: false,
    canWithdraw: false,
    canGet: false,
  },
  {
    id: "cur_zoneztokens",
    title: "Zonez Tokens",
    description: "Zonez Tokens are the token needed to play arcade games in the Neon Zone. You can buy these at the front desk on the right side of Neon Zone Arcade.",
    tradeable: false,
    canWithdraw: false,
    canGet: false,
  },

  ]
}



export default currencyGuide;
